import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BudgetSetupState, GroupTypeRecord } from '../../../models/budget.model';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { CvCustomDialogService } from 'src/app/reusables/custom-dialog/cv-custom-dialog.service';

@Injectable({
    providedIn: 'root'
})
export class BudgetSetupService {

    budgetSetup: BehaviorSubject<BudgetSetupState> = new BehaviorSubject<BudgetSetupState>({
        editMode: true,
        lastIndex: 0,
        selectedGroup: {} as GroupTypeRecord,
    });
    budgetSetup$ = this.budgetSetup.asObservable();

    constructor(
        private dialogService: CvCustomDialogService,
        private cvLocalizationService: CVLocalizationService,
    ) { }

    onBudgetSetupUnsavedChanges(onSuccessCallback: () => void) {
        const message = this.cvLocalizationService.getCachedText("Budget_Setup", "Changes_Lost", "All changes will be lost.");
        this.dialogService.showDialog(
            this.cvLocalizationService.getCachedText("Budget_Setup", "Leave", "Leave?"),
            `<div class="modal-body-text"> ${message} </div>`,
            11,
            this.cvLocalizationService.getCachedText("Budget_Setup", "Stay_Btn", "Stay"),
            this.cvLocalizationService.getCachedText("Budget_Setup", "Leave_Btn", "Leave"),
            true,
            () => {
                onSuccessCallback();
            },
            () => { },
            '',
            true,
            {
                keyboard: false,
                backdrop: 'static',
                centered: true,
                windowClass: 'cxone-modal-budget-setup-container'
            }
        );
    }
}
